export default __webpack_public_path__ + "static/media/kyc-victory.4a11de90.svg";